export default {"src":"/_next/static/media/powerUpTransparent_40.12f9f452.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};